export default __webpack_public_path__ + "static/media/sound2@3x.69bbe544.png";